import { initializeStencilScheduler, prepareAtomicStencilWork } from './stencil-render-scheduler';
import { observeDisconnectedOdsuElements } from './stencil-disconnected-listener-cleanup';
import type { StencilSchedulerCompletion } from './stencil-render-scheduler.model';
import { finishStencilRouteTransition, startStencilRouteTransition } from './stencil-route-transition.store';

let initialized = false;
let transitionVersion = 0;

const handleStencilSchedulerComplete = (completion: StencilSchedulerCompletion) => {
    finishStencilRouteTransition(transitionVersion, completion === 'settled');
};

export const initializeStencilRouteTransition = () => {
    if (initialized) {
        return;
    }

    initialized = true;
    observeDisconnectedOdsuElements(document.documentElement);
    initializeStencilScheduler(handleStencilSchedulerComplete);
    transitionVersion = startStencilRouteTransition();
};

export const prepareStencilRouteTransition = async () => {
    if (!initialized) {
        return;
    }

    transitionVersion = startStencilRouteTransition();
    await prepareAtomicStencilWork();
};
